import { render } from "./Modal2.vue?vue&type=template&id=bcd6937e"
import script from "./Modal2.vue?vue&type=script&lang=js"
export * from "./Modal2.vue?vue&type=script&lang=js"

import "./Modal2.vue?vue&type=style&index=0&id=bcd6937e&lang=css"
script.render = render

export default script